// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"fac2b4895352b9e7aab8","71":"c06c8d6369c72e514138","452":"329657c2ef6aafc79596","885":"bf1f4b80670a337ba1b7","961":"30a0e9840ce82b16a22b"}[chunkId] + ".css";
};